"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var controllers = {
    home: require("@/views/home"),
};
exports.default = controllers;
